import langService from 'spa-ionata-admin/lib/services/Languages';
import StateError from './StateError';
import { getTranslatableKeys } from './Translatable';

interface LocaleItemOptions {
  keys: string[];
}

export default class LocaleItem {
  static debug = false;

  static getLang() {
    return langService.default.code;
  }

  constructor(
    context: HashAny | undefined,
    options: Partial<LocaleItemOptions> = {},
  ) {
    const keys = options.keys ?? getTranslatableKeys(context || {});
    keys.forEach(key => this.addKey(context, key));
  }

  addKey(context: HashAny | undefined, key: string) {
    Object.defineProperty(this, key, {
      enumerable: true,
      configurable: true,
      get: () => this._getter(context, key),
    });
  }

  // A temporary solution until I figure out a way to construct the type (if at all possible)
  asHash() {
    return this as unknown as Hash<string | undefined>;
  }

  _getter(context: HashAny | undefined, key: string): string | undefined {
    if (LocaleItem.debug) {
      if (!context) {
        throw new StateError('no context');
      }
    }
    if (!context) {
      return undefined;
    }
    const translatable = context[key];
    if (!translatable) {
      return undefined;
    }

    const lang = LocaleItem.getLang();
    return translatable[lang] || translatable[langService.default.code];
  }
}
